import './../Filter/Filter.scss';
import Component from './ListingFilter.js';
export default Component;
